import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Switch, Text } from '@chakra-ui/react';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'en';

  const isMarathi = currentLang === 'mr';

  const toggleLanguage = () => {
    i18n.changeLanguage(isMarathi ? 'en' : 'mr');
  };

  return (
    <Flex align="center" gap={2}>
      <Text fontWeight="bold" color={isMarathi ? 'gray.400' : 'blue.500'}>
        EN
      </Text>
      <Switch
        colorScheme="blue"
        isChecked={isMarathi}
        onChange={toggleLanguage}
        size="md"
      />
      <Text fontWeight="bold" color={isMarathi ? 'blue.500' : 'gray.400'}>
        MR
      </Text>
    </Flex>
  );
};

export default LanguageToggle;
